var _createClass = require("/Users/steven/Documents/code/others/fourth_year_project/constellations/node_modules/@babel/runtime/helpers/createClass");

var _classCallCheck = require("/Users/steven/Documents/code/others/fourth_year_project/constellations/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/Users/steven/Documents/code/others/fourth_year_project/constellations/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/steven/Documents/code/others/fourth_year_project/constellations/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/steven/Documents/code/others/fourth_year_project/constellations/node_modules/@babel/runtime/helpers/inherits");

var _wrapNativeSuper = require("/Users/steven/Documents/code/others/fourth_year_project/constellations/node_modules/@babel/runtime/helpers/wrapNativeSuper");

var utils = require('./utils');

var _require = require('./logger'),
    log = _require.log;

var _require2 = require('./models'),
    ActionLog = _require2.ActionLog;

var InvalidScriptFormat =
/*#__PURE__*/
function (_Error) {
  "use strict";

  _inherits(InvalidScriptFormat, _Error);

  function InvalidScriptFormat(message) {
    var _this;

    _classCallCheck(this, InvalidScriptFormat);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(InvalidScriptFormat).call(this, message));
    _this.name = 'InvalidScriptFormat';
    _this.message = message;
    return _this;
  }

  return InvalidScriptFormat;
}(_wrapNativeSuper(Error));

var P2PKH =
/*#__PURE__*/
function () {
  "use strict";

  function P2PKH() {
    _classCallCheck(this, P2PKH);
  }

  _createClass(P2PKH, null, [{
    key: "createScript",
    value: function createScript(recipientAddress, logger) {
      var decodedAddress = utils.b58decode(recipientAddress, logger); // Remove checksum and network bytes

      var pubKeyHash = utils.stripAddress(decodedAddress, logger);
      var OP_DUP = 118;
      var OP_HASH160 = 169;
      var bytesToPush = 14;
      var OP_EQUALVERIFY = 136;
      var OP_CHECKSIG = 172;
      var script = [OP_DUP.toString(16), OP_HASH160.toString(16), bytesToPush, pubKeyHash, OP_EQUALVERIFY.toString(16), OP_CHECKSIG.toString(16)].join('');

      if (logger) {
        log(logger, new ActionLog('Create', "P2PKH script: OP_DUP OP_HASH160 bytes_to_push ".concat(pubKeyHash, " OP_EQUALVERIFY OP_CHECKSIG"), "".concat(script)));
      }

      return script;
    }
  }]);

  return P2PKH;
}();

var P2SH =
/*#__PURE__*/
function () {
  "use strict";

  function P2SH() {
    _classCallCheck(this, P2SH);
  }

  _createClass(P2SH, null, [{
    key: "createScript",
    value: function createScript(p2shAddress, logger) {
      var hexStr = utils.b58decode(p2shAddress, logger);
      var stripped = utils.stripAddress(hexStr, logger);
      var OP_HASH160 = 'a9';
      var bytesToPush = '14';
      var OP_EQUAL = '87';
      var script = "".concat(OP_HASH160).concat(bytesToPush).concat(stripped).concat(OP_EQUAL);

      if (logger) {
        log(logger, new ActionLog('Create', "P2SH script: OP_HASH160 bytes_to_push ".concat(stripped, " OP_EQUAL"), "".concat(script)));
      }

      return script;
    }
  }]);

  return P2SH;
}();

function getScriptFormat(script) {
  var pscript = script.toUpperCase();

  if (pscript.startsWith('76A914') && pscript.endsWith('88AC') && utils.isHexString(script)) {
    return 'pay-to-pubkey-hash';
  }

  if (pscript.startsWith('A914') && pscript.endsWith('87') && utils.isHexString(script)) {
    return 'pay-to-script-hash';
  }

  throw new InvalidScriptFormat('Invalid or unsupported script format.');
}

function createScript(address, logger) {
  var format = utils.getAddressFormat(address);

  switch (format.toUpperCase()) {
    case 'P2PKH':
      return P2PKH.createScript(address, logger);

    case 'P2SH':
      return P2SH.createScript(address, logger);

    default:
      throw new Error('Invalid address format.');
  }
}

module.exports = {
  InvalidScriptFormat: InvalidScriptFormat,
  P2PKH: P2PKH,
  P2SH: P2SH,
  createScript: createScript,
  getScriptFormat: getScriptFormat
};